import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import image4 from "../../Assets/Projects/img4.png";
import image6 from "../../Assets/Projects/img6.png";
import image3 from "../../Assets/Projects/img3.png";
import image1 from "../../Assets/Projects/img1.png";
import image5 from "../../Assets/Projects/img5.png";
import image2 from "../../Assets/Projects/img2.png";
import image7 from "../../Assets/Projects/img7.png";
import image8 from "../../Assets/Projects/img8.png";
import image9 from "../../Assets/Projects/img9.png";
import image10 from "../../Assets/Projects/img10.png";
import image11 from "../../Assets/Projects/img11.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image1}
              isBlog={false}
              title="TERRATRACK"
              description="An Autonomous Agricultural Rover Which collects varios Envionmental data from on board sensors"
              ghLink="https://github.com/dinithaw/TERRATRACK"
              demoLink="https://youtu.be/OwRsXObxDbI?si=5RBSWdWEptxhABMN"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image11}
              isBlog={false}
              title="3D Furniture Configurator"
              description="A 3D Furniture Configurator made using Three.js Next.js and React.js. The app is capable of rendering 3D models of furniture and allows the user to customize the color, size, and texture of the furniture."
              ghLink="https://github.com/dinithaw/3D-furniture-configurature"
              demoLink="https://3dconfig-dlwickramasinghe.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image2}
              isBlog={false}
              title="The Wardrobe"
              description="Full Fledged MERN Stack web app made for clothing store. "
              ghLink="https://github.com/dinithaw/MERN-Fullstack-Website"
              demoLink="https://youtu.be/VyOlm4Ref8I"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image3}
              isBlog={false}
              title="Gym Management System"
              description="C# based desktop application for gym management system. The system is capable of managing members, trainers, equipment, classes, and payments."
              ghLink="https://github.com/dinithaw/GymManagement"
              //demoLink="https://www.youtube.com/@dinithaw"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image4}
              isBlog={false}
              title="Plant AI"
              description="Used the plant disease dataset from Kaggle and trained a image classifer model using 'PyTorch' framework using CNN and Transfer Learning with 38 classes of various plant leaves. The model was successfully able to detect diseased and healthy leaves of 14 unique plants. I was able to achieve an accuracy of 98% by using Resnet34 pretrained model."
              ghLink="https://github.com/dinithaw"
              //demoLink="https://www.youtube.com/@dinithaw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image5}
              isBlog={false}
              title="DJango TEXT TO HASH CONVERTER"
              description="A simple web app made using DJango framework which converts the given text to SHA256 hash."
              ghLink="https://github.com/dinithaw/TEXT-TO-SHA256-CONVERTER-DJANGO-WEB-APP"
              // demoLink="https://www.youtube.com/@dinithaw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image6}
              isBlog={false}
              title="Spendly"
              description="Flutter app which helps to track your daily expenses and income. The app is capable of generating reports and graphs based on the data entered by the user."
              ghLink="https://github.com/dinithaw/Spendly"
              // demoLink="https://www.youtube.com/@dinithaw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image7}
              isBlog={false}
              title="INFIGO20 Buzzer!"
              description="A NODEJS based buzzer app made for the INFIGO20 event."
              ghLink="https://github.com/dinithaw/INFIGO-20-Buzzer-App"
              // demoLink="https://www.youtube.com/@dinithaw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image8}
              isBlog={false}
              title="ChocoLuv"
              description="Dynamic & Beautiful Website for a Chocolate Store made using HTML, CSS, JS, Bootstrap, PHP and MySQL."
              ghLink="https://github.com/dinithaw/chocoluv"
              demoLink="https://dinithaw.github.io/chocoluv/htdocs/index.html"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image9}
              isBlog={false}
              title="XpressMusic"
              description="A Beautiful Web Music Player made using HTML, CSS, JS that purely runs on the browser."
              ghLink="https://github.com/dinithaw/XpressMusic"
              demoLink="https://dinithaw.github.io/XpressMusic/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image10}
              isBlog={false}
              title="InstaUnfollowers"
              description="Web App made using Vanilla JS, HTML & CSS which helps to track the unfollowers on Instagram."
              ghLink="https://github.com/dinithaw/instaunfollowers"
              demoLink="https://dinithaw.github.io/instaunfollowers/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
